import { IUserProviderState } from "../../contexts/UserContext";
import { ISLBatchResponse } from "./SLBatchSchemas";
import { getSLBatchEntry } from "./SLBatchClient";

export function sanitizeBatchEntryFromApi(result: ISLBatchResponse): ISLBatchResponse {
  const batchReponse = {
    id: result.id,
    batchName: result.batchName,
    batchDescription: result.batchDescription,
    batchFileInfo: result.batchFileInfo,
    batchStatus: result.batchStatus,
    purpose: result.purpose,
    refGUID: result.refGUID,
    status: result.status,
    poster: result.poster,
    attachmentInfo: result.attachmentInfo || [],
    rowVer: result.rowVer,
    validationErrors: result.validationErrors || []
  };
  return batchReponse;
}

export async function getBatchEntryFromApi(
  slBatchRefGUID: string,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ISLBatchResponse> {
  const result = await getSLBatchEntry(slBatchRefGUID, getTokenFn);
  if (result === undefined) {
    throw new Error("no result from API");
  }
  const slBatchEntry = sanitizeBatchEntryFromApi(result.data);
  return slBatchEntry;
}
